import { CHANGE_PHONE_COUNTRY_CODE } from 'actions/loginAction';

import update from 'helpers/Immutability';

const login = (state = {}, action) => {
    let mergeState;
    switch (action.type) {
        case CHANGE_PHONE_COUNTRY_CODE:
            mergeState = update(state, {
                countryCode: { $set: action.countryCode },
            });
            break;
        default:
            return state;
    }
    return mergeState;
};
export default login;
